export default class GraphQlGatewayCompatibilityError extends Error {
  path: (string | number)[];

  constructor(message: string, path: string[]) {
    super(message);
    this.path = path;
  }
}
